export default __webpack_public_path__ + "static/media/vrf1.d8fe0101.jpg";